import React from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import qs from 'query-string';

import { toDatesArray } from '../../../../helpers/moment';

const Week = ({
  history,
  location: { search },
  activeDate,
  activeWeek,
  setRefreshCalendar,
  activeSite,
  setLoading,
}) => {
  let activeClass = '  active-day fs-5 fw-medium';
  const params = qs.parse(search);

  const handleChangeShift = (date) => {
    if (activeSite) {
      params.client = activeSite.client_id;
      params.site = activeSite.id;
    }
    setLoading(true);
    history.push({
      pathname: '/smart-scheduler',
      search: qs.stringify({
        ...params,
        date: moment(date).format('YYYY-MM-DD'),
      }),
    });
  };

  return (
    <div className="rounded">
      <div
        className="d-flex justify-items-center nowrap weekCalendar"
        style={{ backgroundColor: '#FAFAFA' }}
      >
        {toDatesArray(activeWeek.startDate, activeWeek.endDate).map(
          (date, index) => (
            <div
              key={index}
              className="flex-grow-1 py-3 text-center"
              onClick={() => handleChangeShift(date)}
            >
              <div className="py-1 pb-2">
                <strong>{moment(date).format('ddd')}</strong>
              </div>
              <div
                className={
                  'pt-1 m-auto ' +
                  (moment(date).format('YYYY-MM-DD') ===
                  moment(activeDate).format('YYYY-MM-DD')
                    ? activeClass
                    : '')
                }
                style={{
                  borderRadius: '50%',
                  height: '40px',
                  width: '40px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
              >
                {moment(date).format('DD')}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default withRouter(Week);
